import { BaseService } from 'core/services';
import DoctorRouteService from './DoctorRouteService';

class DoctorService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new DoctorRouteService());
    }
}

export default DoctorService;
